import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    container: {
      padding: "200px 0",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      gap: "8px"
    },
  };
});
